import './App.css';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Link, Route, Routes} from 'react-router-dom';
import {Apologies, Disclaimer, Layout, Spacer} from './Assets/Assets';
import {Benefits, Carers, ContactUs, Directory, Health, Intro, Mobility, PeerSupport, Services, Signposting, TechnologySupport} from './Pages/Pages';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Layout />}>
            <Route index path='' element={<Intro />} />
            <Route path='Signposting' element={<Signposting />} />
            <Route path='TechnologySupport' element={<TechnologySupport />} />
            <Route path='PeerSupport' element={<PeerSupport />} />
            <Route path='HealthAndWellbeing' element={<Health />} />
            <Route path='Mobility' element={<Mobility />} />
            <Route path='Benefits' element={<Benefits />} />
            <Route path='CarersAndBusiness' element={<Carers />} />
            <Route path='ContactUs' element={<ContactUs />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <div id='site-content'>
        <Apologies />
      </div>
      <Disclaimer />
    </div>
  );
}

export default App;
